module.exports = __webpack_public_path__ + "static/media/worry-free-3.bee3ae3b.png";